// extracted by mini-css-extract-plugin
module.exports = {"container":"primary-button_container__okXVX","button":"primary-button_button__3LMOP","rootClassName":"primary-button_rootClassName__1zu-F"};